/**
 * This class has constants and enums used in library.
 */
export class ESPConstants {
    // End point names
    public static readonly HANDLER_PROV_SCAN = 'prov-scan';
    public static readonly HANDLER_PROTO_VER = 'proto-ver';
    public static readonly HANDLER_PROV_SESSION = 'prov-session';
    public static readonly HANDLER_PROV_CONFIG = 'prov-config';
    public static readonly HANDLER_PROV_MACS = 'prov-macs';
    // Service UUID (Should not be used)
    public static readonly SERVICE_UUID =
        '021a9004-0382-4aea-bff4-6b3f1c5adfb4';
    // Characteristics UUID (Should not be used)
    public static readonly CHARACTERISTICS = {
        'prov-scan': '021aff50-0382-4aea-bff4-6b3f1c5adfb4',
        'proto-ver': '021aff53-0382-4aea-bff4-6b3f1c5adfb4',
        'prov-session': '021aff51-0382-4aea-bff4-6b3f1c5adfb4',
        'prov-config': '021aff52-0382-4aea-bff4-6b3f1c5adfb4',
        'prov-macs': '021aff54-0382-4aea-bff4-6b3f1c5adfb4',
    };
    // Constants for WiFi Security values (As per proto files)
    public static readonly WIFI_OPEN = 0;
    public static readonly WIFI_WEP = 1;
    public static readonly WIFI_WPA_PSK = 2;
    public static readonly WIFI_WPA2_PSK = 3;
    public static readonly WIFI_WPA_WPA2_PSK = 4;
    public static readonly WIFI_WPA2_ENTERPRISE = 5;
    public static readonly WIFI_WPA3_PSK = 6;
    public static readonly WIFI_WPA2_WPA3_PSK = 7;
}

export namespace ESPConstants {
    export enum TransportType {
        TRANSPORT_BLE,
    }

    export enum SecurityType {
        SECURITY_0,
        SECURITY_1,
    }

    export enum ProvisionFailureReason {
        AUTH_FAILED,
        NETWORK_NOT_FOUND,
        DEVICE_DISCONNECTED,
        UNKNOWN,
    }

    export enum ProvisionState {
        UNKNOWN = 0,
        SUCCESS = 1,
        FAILED = 2,
        PROPAGATING = 3,
        WRONG_PARAMS = 4,
        IDLE_NEW = 5,
        IDLE_WIFI = 6,
        IDLE_CONFIGURED = 7,
    }
}
